<template>
  <div class="flex relative mb-2 h-16 preset-image-box">
      <button
        type="button"
        @click="onToggleBanner"
        class="w-full bg-center bg-cover br-10 px-1.5 pt-4"
        :class="{'selected': selected}"
        :style="{backgroundImage: 'url(' + banner.path + ')'}"
        :title="buttonTitle"
      >
      <svg-vue icon="circle-check-solid" class="w-6 h-6 fill-white" v-if="selected" />
      </button>
  </div>
</template>

<script>
export default {
    props: ['selected', 'banner', 'id'],
    methods: {
        onToggleBanner() {
            this.$emit('onToggle', this.id);
        },
    },
    computed: {
        buttonTitle() {
            return this.selected
                ? `Unselect ${this.banner.title} banner image`
                : `Select ${this.banner.title} banner image`;
        },
    },
};
</script>

<style scoped>
.preset-image-box {
    width: 48%;
}
.selected {
   box-shadow: inset 0 0 0 1000px rgb(177 19 19 / 20%);
}
</style>